import React from 'react'
import createIcon from '@/lib/create-icon'

export const PlusSVGIcon = createIcon(
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.50065 3.33333V12.6667M3.83398 8H13.1673"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
)
